<template>
  <el-dialog
    :title="tt('appointmentAlert.title', '预约提醒')"
    :visible.sync="dialogVisible"
    width="500px"
    center
    :before-close="handleClose"
    class="appointment-alert-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    :show-close="true"
  >
    <div class="appointment-alert-container">
      <div class="appointment-alert-icon">
        <i class="el-icon-check" style="color: #52c41a; font-size: 60px;"></i>
      </div>
      
      <div class="appointment-alert-header">
        <h2>{{ tt('appointmentAlert.newAppointment', '新预约通知') }}</h2>
        <p class="appointment-alert-message">
          {{ alertMessage || tt('appointmentAlert.defaultMessage', '您有新的预约需要处理，请及时查看并联系客户') }}
        </p>
      </div>
      
      <div class="appointment-details" v-if="appointmentData">
        <h3>{{ tt('appointmentAlert.details', '预约详情') }}</h3>
        <div class="appointment-detail-item">
          <span class="detail-label">
            <i class="el-icon-user"></i> {{ tt('appointmentAlert.customerName', '客户姓名') }}
          </span>
          <span class="detail-value">{{ appointmentData.customerName || tt('common.none', '无') }}</span>
        </div>
        <div class="appointment-detail-item">
          <span class="detail-label">
            <i class="el-icon-user"></i> {{ tt('appointmentAlert.coachName', '教练姓名') }}
          </span>
          <span class="detail-value">{{ appointmentData.coachName || tt('common.none', '无') }}</span>
        </div>
        <div class="appointment-detail-item">
          <span class="detail-label">
            <i class="el-icon-time"></i> {{ tt('appointmentAlert.appointmentTime', '预约时间') }}
          </span>
          <span class="detail-value">{{ formatDate(appointmentData.appointmentTime) }}</span>
        </div>
        <div class="appointment-detail-item">
          <span class="detail-label">
            <i class="el-icon-s-order"></i> {{ tt('appointmentAlert.serviceName', '服务项目') }}
          </span>
          <span class="detail-value">{{ appointmentData.serviceName || tt('fitnessProject.projectName', '项目名称') }}</span>
        </div>
        <div class="appointment-detail-item">
          <span class="detail-label">
            <i class="el-icon-coin"></i> {{ tt('appointmentAlert.amount', '金额') }}
          </span>
          <span class="detail-value">¥{{ appointmentData.amount || '0' }}</span>
        </div>
        <div class="appointment-detail-item">
          <span class="detail-label">
            <i class="el-icon-wallet"></i> {{ tt('appointmentAlert.paymentMethod', '支付方式') }}
          </span>
          <span class="detail-value">{{ getPaymentMethodText(appointmentData.paymentMethod) }}</span>
        </div>
      </div>
    </div>
    
    <span slot="footer" class="dialog-footer">
      <!-- <el-button @click="handleClose">稍后处理</el-button> -->
      <el-button type="primary" @click="handleViewDetails">{{ tt('appointmentAlert.viewDetails', '查看详情') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'AppointmentAlert',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appointmentData: {
      type: Object,
      default: () => ({})
    },
    alertMessage: {
      type: String,
      default: ''
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        if (!val) {
          this.$emit('close');
        }
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const dialogWrapper = document.querySelector('.appointment-alert-dialog')?.closest('.el-dialog__wrapper');
          if (dialogWrapper) {
            dialogWrapper.style.zIndex = '9999';
          }
        });
      }
    }
  },
  methods: {
    // 本地多语言助手，优先 $t，不存在时使用兜底文案
    tt(key, fallback) {
      try {
        if (this.$t) {
          const res = this.$t(key);
          // $t 返回 key 本身时，使用兜底
          if (typeof res === 'string' && res !== key) return res;
        }
      } catch (e) {}
      return fallback;
    },

    handleClose() {
      this.$emit('close');
    },
    
    handleViewDetails() {
      this.$router.push('/jiaolianyuyue');
      this.handleClose();
    },
    
    formatDate(dateString) {
      console.log('Formatting date:', dateString);
      
      if (!dateString) return this.tt('appointmentAlert.unknownTime', '未知时间');
      try {
        const date = new Date(dateString);
        const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN';
        return date.toLocaleString(locale, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });
      } catch (e) {
        return dateString;
      }
    },
    
    getPaymentMethodText(method) {
      const t = (k, f) => this.tt(k, f);
      const paymentMethods = {
        1: t('payment.onlinePayment', '在线支付'),
        2: t('payment.offlinePayment', '到店付款'),
        '1': t('payment.onlinePayment', '在线支付'),
        '2': t('payment.offlinePayment', '到店付款')
      };
      return paymentMethods[method] || t('missingTranslations.none', '无');
    }
  }
}
</script>

<style scoped>
.appointment-alert-dialog .el-dialog__body {
  padding: 20px 20px 10px 20px;
}

.appointment-alert-container {
  text-align: center;
}

.appointment-alert-icon {
  margin: 10px 0 20px 0;
}

.appointment-alert-header h2 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 22px;
  font-weight: 500;
}

.appointment-alert-message {
  margin: 10px 0 20px 0;
  font-size: 16px;
  color: #666;
  line-height: 1.5;
}

.appointment-details {
  display: none;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 6px;
  margin: 20px 0;
  text-align: left;
}

.appointment-details h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.appointment-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
}

.appointment-detail-item:last-child {
  margin-bottom: 0;
}

.detail-label {
  color: #666;
  display: flex;
  align-items: center;
}

.detail-label i {
  margin-right: 6px;
  width: 16px;
}

.detail-value {
  color: #333;
  font-weight: 500;
  text-align: right;
}

.dialog-footer {
  text-align: center;
  padding: 10px 0;
}

/* 弹窗动画效果 */
.appointment-alert-dialog .el-dialog {
  animation: slideInDown 0.3s ease-out;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 600px) {
  .appointment-alert-dialog {
    margin: 5vh auto;
  }
  
  .appointment-alert-dialog .el-dialog {
    width: 90% !important;
  }
}
</style> 